<template>
  <v-app-bar app color="white" dense clipped-left elevation="2">
    <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    <div class="mx-4 d-flex align-center">
      <Logo class="h-5" />
      <LogoText class="ml-3 h-3" />
    </div>

    <v-spacer></v-spacer>
    <v-btn icon @click="logout">
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import Logo from '@/assets/img/Logo.svg?inline'
import LogoText from '@/assets/img/LogoText.svg?inline'
import { sync } from 'vuex-pathify'

export default {
  name: 'AppBar',

  components: {
    Logo,
    LogoText,
  },

  computed: {
    drawer: sync('app/drawer'),
  },

  methods: {
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin + '/backoffice/',
      })
    },
  },
}
</script>
